import React from "react";
import "./basicLoading.css";

export const BasicLoading = () => (
    <div className="lds-ripple">
        <div></div>
        <div></div>
    </div>
);
